export enum RouteConstants {
  LOGIN = "/login",
  LOGIN_CALLBACK = "/login/callback",
  EYEBALL_GAMES = "/eyeball/games",
  EYEBALL_SESSION_VIEWER = "/eyeball/session/:sessionId",
  EYEBALL_SESSION_COMPARE = "/eyeball/session/:sessionId/compare/:sessionAuthenticatorId",
  TRAINING = "/training",
  TRAINING_CANNED = "/training/canned",
  TRAINING_LIVE = "/training/live",
  TRAINING_REVIEW = "/training/review",
  TRAINING_SESSION_REVIEW = "/training/review/:sessionId",
  TRAINING_CANNED_GAME = "/training/canned/:gamePk",
  TRAINING_LIVE_GAME = "/training/live/:gamePk",
  INVENTORY = "/inventory",
  INVENTORY_HOLOGRAM = "/inventory/:hologram",
  MILESTONES = "/milestones",
  MANAGE = "/manage",
  SETTINGS = "/settings",
  BASE = "/",
}

export default RouteConstants;
